import { withInstall } from '@/utils'
import ParamCodesSelect from './src/paramCodesSelect.vue'
export default withInstall(ParamCodesSelect)
